<ng-container
  *ngrxLet="{
    showCreateSnapshotLoader: remoteDiagnosticsSnapshotsStore.showCreateSnapshotLoader$ | async,
    isAnyVddLoading: vddDetailsListStore.isAnyVddLoading$ | async
  } as showCreateSnapshotLoader"
>
  <mat-card>
    <mat-card-title
      data-at-snapshot-modal-title
      class="!flex flex-row justify-between items-center"
    >
      <span>{{
        '+REMOTE_DIAGNOSTICS_SNAPSHOTS.CREATE_NEW_SNAPSHOT_DIALOG.HEADER' | translate
      }}</span>
      <button mat-icon-button mat-dialog-close>
        <mat-icon>clear</mat-icon>
      </button>
    </mat-card-title>
    <mat-card-content class="flex flex-col">
      <app-snapshot-vdd-selection [gatewaySerial]="data.gatewaySerial">
      </app-snapshot-vdd-selection>

      <app-backup-loader></app-backup-loader>

      <div
        class="vdd-table-container"
        [ngClass]="{
          opacity:
            showCreateSnapshotLoader.showCreateSnapshotLoader ||
            showCreateSnapshotLoader.isAnyVddLoading
        }"
      >
        <app-backup-vdd-table
          (selectedVdd)="removeVddFromList($event)"
          [fullWidthMode]="true"
          [snapshotType]="snapshotType.SNAPSHOT"
          [vdds]="remoteDiagnosticsSnapshotsStore.getSelectedParametersForNewSnapshot$ | async"
          [isCreatingSnapshot]="true"
        ></app-backup-vdd-table>
      </div>
      <div class="flex flex-col">
        <vi-loader
          *ngIf="
            showCreateSnapshotLoader.showCreateSnapshotLoader ||
              showCreateSnapshotLoader.isAnyVddLoading;
            else showActionButtons
          "
          [isLoading]="true"
          message="{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.LOADER.CREATING_SNAPSHOT_TEXT' | translate }}"
        ></vi-loader>

        <ng-template #showActionButtons>
          <div
            class="action-btns flex flex-row lt-md:flex-col gap-[8px] justify-between items-center lt-md:justify-start lt-md:items-start"
          >
            <button
              [disabled]="
                (remoteDiagnosticsSnapshotsStore.isAnyFromSnapshotVddListLoading$ | async) ||
                !(
                  remoteDiagnosticsSnapshotsStore.getSelectedParametersForNewSnapshotLength$ | async
                )
              "
              class="reset-selection-btn"
              gtm="onStart"
              gtmAction="clear all snapshot vdds"
              gtmCategory="vddSnapshots"
              mat-button
              color="primary"
              (click)="removeAllVddsFromList()"
            >
              <mat-icon class="icon">delete</mat-icon
              >{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.RESET_SELECTION' | translate }}
            </button>
            <button
              [disabled]="
                (remoteDiagnosticsSnapshotsStore.isAnyFromSnapshotVddListLoading$ | async) ||
                !(
                  remoteDiagnosticsSnapshotsStore.getSelectedParametersForNewSnapshotLength$ | async
                ) ||
                (remoteDiagnosticsSnapshotService.selectIsAnySelectedParameterInvalid$ | async)
              "
              class="connect-snapshot-btn"
              gtm="onStart"
              gtmAction="save snapshot"
              gtmCategory="vddSnapshots"
              mat-raised-button
              color="primary"
              (click)="generateSnapshot()"
            >
              <mat-icon class="icon">add</mat-icon
              >{{ '+REMOTE_DIAGNOSTICS_SNAPSHOTS.BTN.SAVE_SNAPSHOT' | translate }}
            </button>
          </div>
        </ng-template>
      </div>
    </mat-card-content>
  </mat-card>
</ng-container>
